import React, { Fragment, ReactNode, lazy } from 'react';

import { useFlag } from 'state/launchdarkly';
import { LaunchDarklyFlag } from 'utils/launchdarkly';

export enum CdpProviderTypes {
  MParticle = 'mparticle',
  Bloomreach = 'bloomreach',
}

const CDP_PROVIDER_DEFAULT = CdpProviderTypes.MParticle;

const providersMap = {
  mparticle: lazy(() =>
    import('state/mParticle').then(module => ({ default: module.MParticleProvider }))
  ),
};

export function CdpProvider(props: { children: ReactNode }) {
  const provider = useFlag<CdpProviderTypes>(LaunchDarklyFlag.CDP_PROVIDER) ?? CDP_PROVIDER_DEFAULT;

  const MappedCdpProvider = providersMap[provider] ?? Fragment;

  return <MappedCdpProvider>{props.children}</MappedCdpProvider>;
}
